import { Button } from "@app/components/shadcn/button.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@app/components/shadcn/dropdown-menu.tsx";
import { useTheme } from "@app/components/ThemeProvider.tsx";
import { CheckIcon, Moon, Sun } from "lucide-react";

export function ThemeToggleButton() {
  const { setTheme, theme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <Sun className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
          <Moon className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme("light")}>
          <SpanCheck isChecked={theme === "light"} label="Claro" />
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("dark")}>
          <SpanCheck isChecked={theme === "dark"} label="Escuro" />
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("system")}>
          <SpanCheck isChecked={theme === "system"} label="Sistema" />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

type SpanCheckProps = {
  isChecked: boolean;
  label: string;
};
export const SpanCheck = ({ isChecked, label }: SpanCheckProps) => {
  return (
    <span className="flex items-center gap-2">
      {label}
      {isChecked && <CheckIcon className="h-4 w-4 text-foreground" />}
    </span>
  );
};
